// extracted by mini-css-extract-plugin
export default {"container":"san-diegos-salon_container__8fcJe"};